import { avatarSrc } from "../api/client";

export const Avatar = ({ avatar, name, size = 48, testId }) => {
  const src = avatarSrc(avatar);
  return (
    <div
      data-testid={testId}
      className="rounded-full bg-gray-200 flex items-center justify-center overflow-hidden shrink-0"
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt={name} className="w-full h-full object-cover" />
      ) : (
        <span className="font-semibold text-gray-500" style={{ fontSize: size / 2.5 }}>
          {(name || "?").charAt(0).toUpperCase()}
        </span>
      )}
    </div>
  );
};
